<div class="outerbox">
    <img class="img-responsive" [alt]="employee.pictureAltText" [src]="employee.pictureUrl" />
    <div class="detailsbox">
        <div class="employeename">{{ employee.name }}</div>
        <div class="employeetitle">{{ employee.title }}</div>
    </div>
</div>
